import { post, put } from "./ApiService";
import Cookies from "js-cookie";
import { GUEST_TOKEN, TOKEN_COOKIE } from "./constants";
import { readStoredUserId } from "./sessionIdentity";

export const checkAuthentication = async () => {
    try {
        const token = Cookies.get(TOKEN_COOKIE);
        if (token === GUEST_TOKEN) return false;
        if (token) return true;
        return false;
    } catch {
        return false;
    }
};

export const createInvite = async (projectIdOrUniq, email) => {
    const response = await post("/invites", { project_id: projectIdOrUniq, email });
    return response;
};

export const acceptInvite = async (projectUniqOrId) => {
    // The invite URL uses the project's uniqid (see ShareService.buildInviteUrl).
    // ApiService.put() appends { token: authCookie } for authentication automatically.
    // We send project_id so the backend knows which project the user is joining.
    const userId = readStoredUserId();
    const response = await put("/invites", {
        project_id: projectUniqOrId,
        ...(userId ? { user_id: userId } : {}),
    });
    return response;
};
